module.exports = __webpack_public_path__ + "static/media/07.19d40768.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/07.jpg
// module id = 182
// module chunks = 0